import React from 'react';
import PropTypes from 'prop-types';
import { SortableContainer } from 'react-sortable-hoc';
import SortableItem from './SortableItem';
import styles from './index.less';

const SortableList = props => (
  <div className={styles.stylizedList}>
    {props.items.map((item, index) => (
      <SortableItem
        key={`item-${item.id}`}
        index={index}
        item={item}
        onDelete={props.onDelete}
      />
    ))}
  </div>
);

SortableList.propTypes = {
  items: PropTypes.array,
  onDelete: PropTypes.func.isRequired,
};

SortableList.defaultProps = {
  items: [],
};

export default SortableContainer(SortableList);



// WEBPACK FOOTER //
// ./src/containers/Homepage/SortableList.js